import types from "./types";
import moment from "moment";
import { cosh } from "core-js/core/number";

const executeRequest = (config, axios, values) => {
  const params = {
    action: config.submit.action || "/",
    method: "GET",
    async: true,
  };

  return new Promise((resolve, reject) => {
    const options = {
      method: params.method,
      url: params.action,
    };

    let tempValues = values;
    values = {};
    Object.keys(tempValues).forEach((name) => {
      values[name.replace(/%2E/g, ".")] = tempValues[name];
    });

    options.params = values;

    axios(options)
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        reject(response);
      });
  });
};

function requestBeforeMidnight() {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_BEFORE_MIDNIGHT,
    });
  };
}

function setReachedEndDay(reachedEndOfDay) {
  return (dispatch) => {
    dispatch({
      type: types.SET_REACHED_END_OF_DAY,
      reachedEndOfDay,
    });
  };
}

function setReachedStartDay(reachedStartOfDay) {
  return (dispatch) => {
    dispatch({
      type: types.SET_REACHED_START_OF_DAY,
      reachedStartOfDay,
    });
  };
}

function request(formValues, formConfig) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_REISADVIEZEN,
      formConfig,
      formValues,
    });
  };
}

function requestNext() {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_REISADVIEZEN_NEXT,
    });
  };
}

function filterPlansByDate(plans, intervalDate) {
  return plans.filter(
    (plan) => new Date(plan.startTime).getDate() == intervalDate
  );
}

async function requestPrevNext(formValues, formConfig, axios) {
  const response = await executeRequest(formConfig, axios, formValues);
  let itineraries = [];
  try {
    itineraries = response.data.result.result.plan.itineraries || [];
  } catch (ex) {}

  let plans = itineraries.map(
    ({
      departureDelay,
      arrivalDelay,
      transfers,
      fare,
      legs,
      realtimeInfo = {},
      occupancy,
    }) => {
      const { cancellations, ludMessages = [] } =
        realtimeInfo === null ? {} : realtimeInfo;
      let startTime = legs[0].startTime;
      let endTime = legs[legs.length - 1].endTime;
      let duration = endTime - startTime;

      let startTimeDelay = departureDelay;
      let endTimeDelay = arrivalDelay;

      const cancelled = cancellations === "Cancellations";

      let fareInfo = undefined;
      if (fare && fare.fare.regular) {
        fareInfo = {
          price: !fare.fare.regular.cents ? 0 : fare.fare.regular.cents / 100.0,
          currency: !(
            fare.fare.regular.currency && fare.fare.regular.currency.currency
          )
            ? "EUR"
            : fare.fare.regular.currency.currency,
        };
      }

      return {
        duration,
        //durationDelay
        startTime,
        endTime,
        startTimeDelay,
        endTimeDelay,
        transfers,
        fare: fareInfo,
        legs,
        cancelled,
        ludMessages,
        occupancy,
      };
    }
  );
  return { response, plans };
}

function receivedNext(formValues, formConfig, selectedDate, axios) {
  return async (dispatch) => {
    var tripInfo = await requestPrevNext(formValues, formConfig, axios);

    const initialPlansLength = tripInfo.plans.length;

    const requestDay = parseInt(
      moment(formValues["date"], "DD-MM-YYYY").format("DD")
    );

    const selectedDay = parseInt(
      moment(selectedDate, "DD-MM-YYYY").format("DD")
    );

    var plans = filterPlansByDate(tripInfo.plans, selectedDay);

    if (
      initialPlansLength !== plans.length ||
      parseInt(moment(selectedDate, "DD-MM-YYYY").format("DD")) != requestDay
    ) {
      dispatch(setReachedEndDay(true));
    }

    var noNextResponseForInterval = plans.length === 0;

    const plannerType = tripInfo.response.data.result.planner;

    const nextDateTime =
      tripInfo.response.data.result.result.metadata.nextDateTime;

    dispatch({
      type: types.RECEIVED_REISADVIEZEN_NEXT,
      plans,
      plannerType,
      nextDateTime,
      noNextResponseForInterval,
    });
  };
}

function requestPrev() {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_REISADVIEZEN_PREV,
    });
  };
}

function receivedPrev(formValues, formConfig, selectedDate, axios) {
  return async (dispatch) => {
    const tripInfo = await requestPrevNext(formValues, formConfig, axios);

    const initialPlansLength = tripInfo.plans.length;

    const requestDay = parseInt(
      moment(formValues["date"], "DD-MM-YYYY").format("DD")
    );

    const selectedDay = parseInt(
      moment(selectedDate, "DD-MM-YYYY").format("DD")
    );

    const plans = filterPlansByDate(tripInfo.plans, selectedDay);

    if (
      initialPlansLength !== plans.length ||
      parseInt(moment(selectedDate, "DD-MM-YYYY").format("DD")) != requestDay
    ) {
      dispatch(setReachedStartDay(true));
    }

    const noPrevResponseForInterval = plans.length === 0;

    const plannerType = tripInfo.response.data.result.planner;

    const prevBatchLength = plans.length;

    const prevDateTime =
      tripInfo.response.data.result.result.metadata.prevDateTime;

    dispatch({
      type: types.RECEIVED_REISADVIEZEN_PREV,
      plans,
      plannerType,
      prevBatchLength,
      prevDateTime,
      noPrevResponseForInterval,
    });
  };
}

function received(
  response,
  formValues,
  formConfig,
  prevTime,
  nextTime,
  pageIndex = 0
) {
  return (dispatch, getState) => {
    if (!response.data && pageIndex === 0) {
      dispatch({
        type: types.RECEIVED_REISADVIEZEN,
        formConfig,
        formValues,
        plans: [],
      });
      return;
    }
    if (response.data.error && pageIndex === 0) {
      dispatch({
        type: types.RECEIVED_REISADVIEZEN,
        formConfig,
        formValues,
        plans: [],
      });
      return;
    }

    let itineraries = [];
    try {
      itineraries = response.data.result.result.plan.itineraries || [];
    } catch (ex) {}

    let metadata = [];
    if (response.data.result.result.metadata)
      metadata = response.data.result.result.metadata;

    prevTime =
      prevTime == null || prevTime == undefined
        ? undefined
        : prevTime.getTime();
    nextTime =
      nextTime == null || nextTime == undefined
        ? undefined
        : nextTime.getTime();

    let plans = itineraries.map(
      ({
        departureDelay,
        arrivalDelay,
        transfers,
        fare,
        legs,
        realtimeInfo = {},
        occupancy,
      }) => {
        const { cancellations, ludMessages = [] } =
          realtimeInfo === null ? {} : realtimeInfo;
        //Todo (24-2-2019): Retreive delays from itineraries for OTP and 9292

        //OTP (The data is not yet provided on itineraries level, only on legs level)
        let startTime = legs[0].startTime;
        let endTime = legs[legs.length - 1].endTime;
        let duration = endTime - startTime;

        let startTimeDelay = departureDelay;
        let endTimeDelay = arrivalDelay;

        const cancelled = cancellations === "Cancellations";

        let fareInfo = undefined;
        if (fare && fare.fare.regular) {
          fareInfo = {
            price: !fare.fare.regular.cents
              ? 0
              : fare.fare.regular.cents / 100.0,
            currency: !(
              fare.fare.regular.currency && fare.fare.regular.currency.currency
            )
              ? "EUR"
              : fare.fare.regular.currency.currency,
          };
        }

        return {
          duration,
          //durationDelay
          startTime,
          endTime,
          startTimeDelay,
          endTimeDelay,
          transfers,
          fare: fareInfo,
          legs,
          cancelled,
          ludMessages,
          occupancy,
        };
      }
    );

    let origin = "?";
    let destination = "?";
    let targetIsArrivalTime = false;
    let selectedDate = "?";
    try {
      if (formValues["arrive"]) targetIsArrivalTime = true;
      if (formValues["from"])
        origin = (
          typeof formValues["from"] === "string"
            ? JSON.parse(formValues["from"])
            : formValues["from"]
        ).description;
      if (formValues["date"]) selectedDate = formValues["date"];
      if (formValues["to"])
        destination = (
          typeof formValues["to"] === "string"
            ? JSON.parse(formValues["to"])
            : formValues["to"]
        ).description;
    } catch (ex) {}

    const plannerType = response.data.result.planner;

    // const state = getState()
    // let startPageIndex = 0
    // let endPageIndex = 0
    // if(state.reisadviezen && state.reisadviezen.plans) {
    //   startPageIndex = state.reisadviezen.startPageIndex
    //   endPageIndex = state.reisadviezen.endPageIndex

    //   if(pageIndex < 0) {
    //     startPageIndex = pageIndex
    //     plans = state.reisadviezen.plans.concat(plans);
    //   } else if(pageIndex > 0) {
    //     endPageIndex = pageIndex
    //     plans = plans.concat(state.reisadviezen.plans);
    //   }
    // }

    dispatch({
      type: types.RECEIVED_REISADVIEZEN,
      formConfig,
      formValues,
      metadata,
      prevTime,
      nextTime,
      plans,
      plannerType,
      origin,
      destination,
      targetIsArrivalTime,
      selectedDate,
      //startPageIndex,
      //endPageIndex
    });

    dispatch(setReachedEndDay(false));
    dispatch(setReachedStartDay(false));
  };
}

function failed(isPageRequest = false) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_REISADVIEZEN_FAILED,
      isPageRequest,
    });
  };
}

function select(selectedIndex) {
  return (dispatch) => {
    dispatch({
      type: types.SELECTED_REISADVIES,
      selectedIndex,
    });
  };
}

function flexRequest(formValues, formConfig) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_FLEX_REISADVIEZEN,
      formConfig,
      formValues,
      flexType: formValues.flex,
    });
  };
}

function flexReceived(response, formValues, formConfig) {
  return (dispatch, getState) => {
    if (!response.data || response.data.error) {
      dispatch({
        type: types.RECEIVED_FLEX_REISADVIEZEN,
        formConfig,
        formValues,
        flexType: formValues.flex,
      });
      return;
    }

    let result = {};
    try {
      result = response.data.result || {};
    } catch (ex) {}

    const flexInformation = {
      flex: result.flex,
      tripAvailable: result.tripAvailable,
      remarks: result.remarks,
      orderUrl: result.orderUrl,
    };

    dispatch({
      type: types.RECEIVED_FLEX_REISADVIEZEN,
      formConfig,
      formValues,
      plannerType: result.planner,
      flexType: formValues.flex,
      flexInformation: flexInformation,
    });
  };
}

function flexFailed(response, formValues, formConfig) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_FLEX_REISADVIEZEN_FAILED,
      formConfig,
      formValues,
      flexType: formValues.flex,
    });
  };
}

export default {
  requestBeforeMidnight,
  request,
  requestNext,
  requestPrev,
  receivedPrev,
  receivedNext,
  failed,
  received,
  select,
  flexRequest,
  flexReceived,
  flexFailed,
  setReachedEndDay,
  setReachedStartDay,
};



// WEBPACK FOOTER //
// ./src/actions/reisadviezen.js